<template>
    <div class=" text-center w-full ">
        <img :src="getImageUrl(item.img)" class="p-0 mb10" width="80px" height="80px" alt="...">
        <p class="w-full beneficioText">{{ item.text }}</p>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        item: {
            type: Object,
        },
    },
    methods: {
        getImageUrl(imgPath) {
            return `${window.location.origin}/${imgPath}`;
        }
    }
};
</script>

<style scoped></style>